import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import ItemCard from "./ItemCard";
import { makeStyles } from "@material-ui/core/styles";
import GridList from "@material-ui/core/GridList";
import Filter from "./Filter";
import PageLoader from "../../layout/PageLoader";
import { incrementCartItems } from "../../store/actions/cartActions";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { HomeCarousel } from "../../layout/Carousel";

const useStyles = makeStyles(theme => ({
  overlay: {
    zIndex: 3000
  },
  root: {
    marginBottom: "100px",
    color: "#3b5998"
  },
  products: {
    marginTop: 15,
    margin: "0 auto"
  },
  main: {
    display: "flex",
    flexWrap: "wrap"
  },
  cartContainer: {
    position: "fixed",
    top: 0,
    backgroundColor: "#f5f5f5",
    width: "100%",
    height: "100%",
    overflowX: "hidden"
  },
  cart: {
    margin: "0 auto",
    paddingTop: "200px",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "100px"
    }
  },
  grid: {
    margin: "0 auto",
    justifyContent: "center"
  },
  filter: {
    margin: "0 auto"
  }
}));

const Home = props => {
  const classes = useStyles();
  let { inventory, incrementCart, cart } = props;
  let storedItems = JSON.parse(localStorage.getItem("cartItems")) || [];
  const [cartValue, setCartValue] = useState(storedItems);

  useEffect(() => {
    if (inventory) {
      setTimeout(() => {
        setHideLoader(true);
      }, 1500);
    }
  }, [inventory]);

  let count = 0;
  inventory ? (count = inventory.length) : (count = 0);

  const [hideLoader, setHideLoader] = useState(false);
  const [filterValue, setFilterValue] = useState(null);
  const [sortValue, setSortValue] = useState(null);

  const filterProducts = event => {
    setFilterValue(event.target.value);
  };
  const sortProducts = event => {
    setSortValue(event.target.value);
  };

  const addToCart = product => {
    const cartItems = cartValue.slice();
    let counter = Number(localStorage.getItem("cartCounter"));
    let alreadyInCart = false;
    counter++;
    localStorage.setItem("cartCounter", counter);

    cartItems.forEach(item => {
      if (item.id === product.id) {
        item.count++;
        alreadyInCart = true;
      }
    });

    if (!alreadyInCart) {
      cartItems.push({ ...product, count: 1 });
    }

    setCartValue(cartItems);
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
    incrementCart(counter, cartItems);
  };

  return !hideLoader ? (
    <div className={classes.overlay}>
      <PageLoader />
    </div>
  ) : (
    <div className={classes.root}>
      <div className={classes.main}>
        {/*<Filter
          count={count}
          filterProducts={filterProducts}
          sortProducts={sortProducts}
          className={classes.filter}
        ></Filter>*/}

        <HomeCarousel></HomeCarousel>
        <div className={classes.products}>
          <GridList cols={3} className={classes.grid}>
            {filterValue
              ? inventory &&
                inventory
                  .filter(item =>
                    filterValue ? item.tags.includes(filterValue) : null
                  )
                  .slice()
                  .sort((a, b) =>
                    sortValue === "lowest"
                      ? a.price > b.price
                        ? 1
                        : -1
                      : sortValue === "highest"
                      ? a.price < b.price
                        ? 1
                        : -1
                      : a.name > b.name
                      ? 1
                      : -1
                  )
                  .map(item => {
                    if (item.isVisible) {
                      return <ItemCard item={item} key={item.code}></ItemCard>;
                    } else {
                      console.log("item is hidden");
                      return null;
                    }
                  })
              : sortValue
              ? inventory &&
                inventory
                  .slice()
                  .sort((a, b) =>
                    sortValue === "lowest"
                      ? a.price > b.price
                        ? 1
                        : -1
                      : sortValue === "highest"
                      ? a.price < b.price
                        ? 1
                        : -1
                      : a.name > b.name
                      ? 1
                      : -1
                  )
                  .map(item => {
                    if (item.isVisible) {
                      return (
                        <ItemCard
                          item={item}
                          key={item.code}
                          add={addToCart}
                          cart={cart}
                        ></ItemCard>
                      );
                    } else return null;
                  })
              : inventory &&
                inventory.map(item => {
                  if (item.isVisible) {
                    return (
                      <ItemCard
                        item={item}
                        key={item.code}
                        add={addToCart}
                        cart={cart}
                      ></ItemCard>
                    );
                  } else return null;
                })}
          </GridList>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  incrementCart: (counter, items) => {
    dispatch(incrementCartItems(counter, items));
  }
});

const mapStateToProps = state => {
  let inventory = state.firestore.ordered.inventory;
  let inStock = [];
  if (inventory) {
    inStock = inventory.filter(item => {
      return item.amountAvailable > 0;
    });
  }

  return {
    inventory: inStock,
    auth: state.firebase.auth,
    cart: state.cart
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  firestoreConnect([{ collection: "inventory" }])
)(Home);
